document.addEventListener('DOMContentLoaded', function () {
  var stickyAddToCart = document.querySelector('.sticky-add-to-cart');
  var productInfoContainer = document.querySelector('.product-info-container');
  var footer = document.querySelector('#site-footer');

  if (!stickyAddToCart || !productInfoContainer) {
    return;
  }

  function updateStickyAddToCartVisibility() {
    var sectionBottom = productInfoContainer.getBoundingClientRect().bottom;
    var isPastMainProduct = sectionBottom <= 0;
    var isFooterVisible = false;

    if (footer) {
      var footerRect = footer.getBoundingClientRect();
      isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
    }

    stickyAddToCart.style.display = isPastMainProduct && !isFooterVisible ? 'block' : 'none';
  }

  function updateStickyAddToCart() {
    updateStickyAddToCartVisibility();
  }

  var scrollToRitualButton = stickyAddToCart.querySelector('.js-scroll-to-ritual');
  if (scrollToRitualButton) {
    scrollToRitualButton.addEventListener('click', function () {
      var ritualPicker = document.querySelector('ritual-picker');
      if (!ritualPicker) return;

      ritualPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  updateStickyAddToCart();
  window.addEventListener('scroll', updateStickyAddToCart, { passive: true });
  window.addEventListener('resize', updateStickyAddToCart);
});
